import { getEntityMap } from './selectors'

export const GRAPHQL_DATA_REMOVED = 'GRAPHQL/DATA_REMOVED'

const noop = x => x

export function dataRemoved(payload) {
  return {
    type: GRAPHQL_DATA_REMOVED,
    payload, // {id, typename} or array of same shape
  }
}

export function dataRemovedReducerFactory({ extraRemoveReducer }) {
  return function dataRemovedReducer(state, payload) {
    const { __typename, id } = payload
    const typenameMap = getEntityMap(state, __typename)
    if (!typenameMap) {
      return state
    }
    const extraReducer = extraRemoveReducer[__typename] || noop
    return extraReducer(state.set(__typename, typenameMap.delete(id)), payload)
  }
}
